import BossModel from "@/models/BossModel";
import Product from "@/models/Product/Product";
import Detail from "@/models/Product/Detail/Detail";
import CachedProductPrice from "@/models/CachedProductPrice/CachedProductPrice";
import Purchase from "@/models/Product/Detail/Composition/Purchase/Purchase";
import Allowance from "@/models/Product/Allowance/Allowance";
import CompositionAllowance from "@/models/Product/Detail/Composition/CompositionAllowance";
import Discount from "@/models/Product/Discount/Discount";
import CompositionDiscount from "@/models/Product/Detail/Composition/CompositionDiscount";
import Concept from "@/models/Product/Detail/Composition/Purchase/Concept/Concept";

export default class Composition extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/detail/composition';

    /**
     *
     * @type {string}
     */
    static entity = 'productDetailCompositions';

    constructor(data) {
        super(data);
        this.count = 0;
    }

    static fields() {
		return {
			id: this.number(null).nullable(),
			product_detail_id: this.number(null).nullable(),
			code: this.attr(null),
			min_adult: this.number(null).nullable(),
			max_adult: this.number(null).nullable(),
			min_child: this.number(null).nullable(),
			max_child: this.number(null).nullable(),
			min_baby: this.number(null).nullable(),
			max_baby: this.number(null).nullable(),
			min_duration: this.number(null).nullable(),
			max_duration: this.number(null).nullable(),
			is_active: this.boolean(null),
            sort_order: this.number(null),
			travalco_eid: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
			product_price_purchase_group_id: this.attr(null),
            productDetail: this.belongsTo(Detail, 'product_detail_id'),
            detail: this.belongsTo(Detail, 'product_detail_id'),
            composition_cached_prices: this.hasOne(CachedProductPrice, 'product_detail_composition_id'),
            purchases: this.hasMany(Purchase, 'product_detail_composition_id'),
            currentPurchases: this.hasMany(Purchase, 'product_detail_composition_id'),
            concepts: this.hasMany(Concept, 'product_detail_composition_id'),
            activePurchases: this.hasMany(Purchase, 'product_detail_composition_id'),
            allowances: this.belongsToMany(Allowance, CompositionAllowance, 'product_detail_composition_id', 'product_allowance_id'),
            activeAllowances: this.belongsToMany(Allowance, CompositionAllowance, 'product_detail_composition_id', 'product_allowance_id'),
            discounts: this.belongsToMany(Discount, CompositionDiscount, 'product_detail_composition_id', 'product_discount_id'),
            activeDiscounts: this.belongsToMany(Discount, CompositionDiscount, 'product_detail_composition_id', 'product_discount_id'),
		}
	}

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    Destroy(){
        return this.api().delete();
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    saveProductDetailComposition(){
        return this.constructor.api().create(this);
    }

    /**
     *
     * @returns {boolean|*}
     */
    ProductDetail(){
        return this.getRelated('productDetail');
    }


    /**
     *
     * @param lineProductProduct
     * @returns {number|*}
     */
    IsBookedInProduct(lineProductProduct){
        let matchedDetails = lineProductProduct.getDetails().find(lineProductDetail => lineProductDetail.product_detail_composition_id === this.id)
        if(matchedDetails !== undefined){
            return lineProductProduct.getDetails().find(lineProductDetail => lineProductDetail.product_detail_composition_id === this.id);
        } else {
            return 0
        }
    }

    PurchaseGroup() {
        return this.getRelated('purchaseGroup');
    }

    HasPurchaseGroup() {
        return this.product_price_purchase_group_id !== null;
    }

    /**
     * @param startDate
     * @param endDate
     * @param adults
     * @param children
     * @param babies
     */
    async SalePrice(startDate, endDate, adults, children = 0, babies = 0) {
        let productId = this.ProductDetail().Product().id;
        return Product.getPossibleCombinations(productId, adults, children, babies, startDate, endDate).then((response) => {
            let options = Object.values(response.options);
            let foundOption = options.find(item => item.product_detail_composition_id === this.id);

            if (foundOption === undefined) {
                return Promise.reject('Geen optie gevonden');
            }

            if (response.prediction !== undefined) {
                foundOption.prediction = response.prediction;
            }

            return foundOption;
        });
    }
}
